import React, { PureComponent } from 'react';

import { connect } from 'react-redux';

import styled from 'styled-components';

import { AppState } from '@redux/types';
import {
  ProfileCountry,
  PurchasedSubscription,
} from '@redux/reducers/profile/types';
import { _getCountries } from '@redux/reducers/countries/selectors';
import {
  _getProfile,
  _getPurchasedSubscriptions,
} from '@redux/reducers/profile/selectors';
import { _isAuthorized } from '@redux/reducers/auth/selectors';
import { getPurchasedInfo } from '@redux/reducers/profile/action';
import { login } from '@redux/reducers/auth/action';

import Box from '../atoms/Box/Box';
import Button from '../atoms/Button/Button';
import CSSMediaQuery, { ShowOn } from '../atoms/CSSMediaQuery/CSSMediaQuery';
import Image from '../atoms/Image/Image';
import Text from '../atoms/Text/Text';
import SignOutPopup from '../organisms/SignOutPopup';

import { BillingHistory } from '@shared/interfaces/billing-history';
import { Color } from '@shared/enums/button-color';
import { HaveAccountPopup } from '@hoc/HaveAccountPopup';
import { I18nTranslation } from '@shared/interfaces/i18n';
import { Size } from '@shared/enums/button-size';
import { breakpoint } from 'theme';
import { withTranslation } from 'i18n';

const BoxAppNameInLine = styled(Box)`
  height: 66px;
  z-index: 1;
  box-shadow: 0 0 6px 0 ${({ theme }) => theme.transparentColors.black25};
`;

const WrapperInner = styled(Box)`
  display: flex;
  align-items: center;

  margin-left: auto;
`;

const ButtonExtend = styled(Button)`
  position: relative;
  right: 1em;
  text-transform: uppercase;
  font-weight: 700;
  text-align: center;
  font-size: 1em;
  height: 50px;
  width: auto;
  padding: 13px 15px;

  ${breakpoint.sm`
    font-size: 0.9em;
  `}
`;

const BoxReseller = styled(Box)`
  display: flex;
`;

type AppNameInLineProps = {
  className?: string;
  country: ProfileCountry;
  isAuthorized?: boolean;
  resellerImage?: string;
  dispatch: (data: any) => void;
  subscriptions?: PurchasedSubscription[];
  billingHistory?: BillingHistory[];
  t: I18nTranslation;
  showHaveAccountPopup?: (
    p: () => void,
    e: React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ) => void;
};

class AppNameInLine extends PureComponent<AppNameInLineProps> {
  state = {
    isOpenLogoutPopup: false,
  };

  handleShow = () => {
    this.setState({
      isOpenLogoutPopup: true,
    });
  };

  handleClose = () => {
    this.setState({
      isOpenLogoutPopup: false,
    });
  };

  handleClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    const { isAuthorized, dispatch, showHaveAccountPopup } = this.props;

    if (isAuthorized) {
      this.handleShow();
    } else {
      showHaveAccountPopup(async () => {
        try {
          await dispatch(login());
        } catch (error) {
          console.warn(error);
        }
      }, e);
    }
  };

  componentDidMount() {
    this.props.dispatch(getPurchasedInfo());
  }

  render() {
    const {
      isAuthorized,
      resellerImage,
      className,
      t,
      subscriptions,
      billingHistory,
    } = this.props;

    let buttonColorType = Color.FullGreen;
    let buttonText = t('login');

    if (isAuthorized) {
      buttonColorType = Color.TransparentGrey;
      buttonText = t('logout');
    }

    const isDiscount = (subscriptions.length || billingHistory.length) > 0;

    return (
      <>
        <BoxAppNameInLine
          role="region"
          ariaLabel={isAuthorized ? "Account Sign Out" : "Account Sign In"}
          className={className}
          smPr={0.875}
          smPl={0.875}
          pt={0.5}
          pr={0.125}
          pb={0.5}
          pl={1.75}
          backgroundColor="white"
        >
          {resellerImage && (
            <CSSMediaQuery showOn={[ShowOn.Tablet, ShowOn.Desktop]}>
              <BoxReseller backgroundColor="white">
                <Box mr={0.5}>
                  <Text
                    size={1.125}
                    color={Color.GrayChateau}
                    lineHeight="normal"
                  >
                    in partnership with
                  </Text>
                </Box>
                <Image src={resellerImage} height={2} />
              </BoxReseller>
            </CSSMediaQuery>
          )}

          <WrapperInner>
            <Box pl={0.875}>
              <ButtonExtend
                colorType={buttonColorType}
                sizeType={Size.Small}
                onClick={this.handleClick}
              >
                {buttonText}
              </ButtonExtend>
            </Box>
          </WrapperInner>
        </BoxAppNameInLine>

        {this.state.isOpenLogoutPopup && (
          <SignOutPopup
            handleCloseSignOutPopup={this.handleClose}
            isDiscount={isDiscount}
            dispatch={this.props.dispatch}
          />
        )}
      </>
    );
  }
}

const styledAppNameInLine = styled(withTranslation('common')(AppNameInLine))`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const withConnect = connect((state: AppState) => {
  const profile = _getProfile(state);

  return {
    country: profile.country,
    isAuthorized: _isAuthorized(state),
    countries: _getCountries(state),
    subscriptions: _getPurchasedSubscriptions(state),
    billingHistory: profile.billingHistory,
  };
});

export default HaveAccountPopup(withConnect(styledAppNameInLine));
